import { lazy } from 'react';
import AuthRoles from '@/app/auth/authRoles';

const CompanyServicesSummaryPage = lazy(() => import('./CompanyServicesSummaryPage'));

const CompanyServicesSummaryConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: AuthRoles.CompanySummary,
  routes: [
    {
      path: 'company-services-summary',
      element: <CompanyServicesSummaryPage />,
    },
  ],
};

export default CompanyServicesSummaryConfig;
